import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  CHAPTER_FINANCE_ACCESS_GET,
  CHAPTER_FINANCE_ACCESS_UPDATE,
  USER_ROLE_LIST_DROPDOWN
} from "../../routes/routes";
import { toast } from "react-toastify";
import { CHAPTER_FINANCE_ACCESS_UPDATED } from "../../constant/constant";
import { FullPageLoader } from '../../components/common/Loader'; // Import the loader component
import "flatpickr/dist/themes/material_red.css";
import Select from "react-select";


const EditChapterFinanceAccess = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [roleOptions, setRoleOptions] = useState({});

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(CHAPTER_FINANCE_ACCESS_UPDATE, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(CHAPTER_FINANCE_ACCESS_UPDATED);
          navigate("/chapter-finance-access");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios.get(CHAPTER_FINANCE_ACCESS_GET).then((res) => {
      if (res.status === 200 && res.data.success) {
        let responseData = res.data.data;
        setForm({
          user_roles: responseData?.user_roles,
          user_roles_selected: responseData?.user_roles_selected,
        });
      }
    }).finally(() => {
      setLoading(false);
    });

    const fetchData = async () => {
      try {
        // Fetch role data
        const roleResponse = await axios.get(USER_ROLE_LIST_DROPDOWN);
        const fetchedRoleOptions = roleResponse.data.data;
        setRoleOptions(fetchedRoleOptions);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Chapter Finance Access</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit Chapter Finance Access</span></li>
              </ol>
            </div>
            {/* removed back button logic based on exact original template structure (it linked back to timers which isn't applicable directly, or we can just leave it out) */}
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
              </div>
              <div className="card-body">
                <form>
                  <div className="row">

                    <div className="col-12 mb-3">
                      <label htmlFor="user_roles" className="form-label">
                        User Role<span className="text-danger">*</span>
                      </label>
                      <Select
                        isMulti={true}
                        options={roleOptions}
                        value={form?.user_roles_selected}
                        onChange={(selected) => setForm({
                          ...form,
                          user_roles: selected ? selected.map(opt => opt.value) : [],
                          user_roles_selected: selected
                        })}
                      />
                      <ValidationMessage error={errors} name="user_roles" />
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditChapterFinanceAccess;
